/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Box, Collapse, Flex, Heading, IconButton, Text } from "@chakra-ui/react"
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons"
import { useState } from "react"
import { useLocation } from "react-router-dom"
import { breadCrumbFMPSecondLevel, breadCrumbFirstLevel, headerFooterContentWidth, headerFooterMaxWidth } from "../../../common/commonConstants"
import { SubPage, SubPageContent } from "../../../components/SubPage"
import { BreadCrumb } from "../../../components/commons/breadcrumb"
import { Colors } from "../../../theme/colors"
import { FMPActionButtons } from "../common.fmp.components/FMPActionButtons"
import { type SelectedFMPType } from "../addToFMPDropdown/addToFMPDropdown"
import { FMPFilterForm } from "./productFilter.support.form"
import FMPTable from "./productFilter.support.tabls"

export const ProductFilter = (): JSX.Element => {
  const location = useLocation()
  const { fmpId } = (location.state as { fmpId?: number }) ?? { fmpId: undefined }
  const [activeProject, setActiveProject] = useState<SelectedFMPType | null>(null)
  const [isFiltersExpanded, setIsFiltersExpanded] = useState(true)
  const activeFmpId = activeProject?.selectedFMP.id

  return (
    <SubPage>
      <BreadCrumb
        options={{
          ...breadCrumbFirstLevel,
          ...breadCrumbFMPSecondLevel,
          thirdLevel: { title: "Edit FMP" },
          fourthLevel: { title: "Edit Systems" }
        }}
      />

      <SubPageContent props={{ pt: "22px" }} innerBoxProps={{ w: headerFooterContentWidth, maxW: headerFooterMaxWidth }}>
        <Flex justifyContent="space-between" alignItems="center" w="100%" pb="2" mb="3">
          <Heading variant={"RHeading1"} textAlign="left" color="primary">
            Fire Management Plan - Systems
          </Heading>
          <FMPActionButtons fmpId={activeFmpId} pageType="filter" />
        </Flex>

        <Box display="grid" gridTemplateColumns="1fr auto" alignItems="center" gridGap="8px" mb="4">
          <Box height="1px" bg={Colors.Alternative["900"]} />
          <Flex alignItems="center" gap="4px">
            <Text variant="RCaptionBold" color={Colors.Alternative.accent} fontSize="16px">
              Select Filters
            </Text>
            <IconButton
              aria-label={isFiltersExpanded ? "Collapse filters" : "Expand filters"}
              icon={isFiltersExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
              size="xs"
              variant="ghost"
              bg={Colors.Alternative.accent}
              color="white"
              fontSize="18px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              _hover={{ bg: "#8B6B5E" }}
              onClick={() => { setIsFiltersExpanded(!isFiltersExpanded) }}
            />
          </Flex>
        </Box>

        <Collapse in={isFiltersExpanded} animateOpacity>
          <FMPFilterForm />
        </Collapse>

        <Box display="grid" gridTemplateColumns="1fr auto" alignItems="center" gridGap="8px" mb="4">
          <Box height="1px" bg={Colors.Alternative["900"]} />
          <Text variant="RCaptionBold" color="primary" fontSize="16px">
            Fire Stopping Systems
          </Text>
        </Box>

        <FMPTable activeProject={activeProject} onDropdownChange={setActiveProject} defaultFmpId={fmpId} />
      </SubPageContent>
    </SubPage>
  )
}
